import logo from "../imges/Beto_Photography-1-removebg-preview.png";
import menuIcon from "../icons/menuIco.svg";
import closeIcon from "../icons/closeIcon.svg";
import "../styles/header.css";
import { useRef } from "react";
import { Link } from "react-router-dom";

export default function Header() {
  let ulRef = useRef();
  const handleOPenMenu = () => {
    ulRef.current.classList.add("active");
  };
  const handleCloseMenu = () => {
    ulRef.current.classList.remove("active");
  };
  return (
    <>
      <section className="NavBar">
        <div className="container-nav">
          <div className="container-left">
            <div className="container-logo">
              <div className="img">
                <img src={logo} alt="Beto" loading="lazy" />
              </div>
            </div>
            <div className="container-menu"></div>
          </div>
          <div className="container-right">
            <div className="responsive_menu" onClick={handleOPenMenu}>
              <img src={menuIcon} alt="" />
            </div>
            <ul className="container-right" ref={ulRef}>
              <img
                src={closeIcon}
                onClick={handleCloseMenu}
                className="closeSVG"
                alt=""
              />
              <li>
                <Link to="/"> Home </Link>
              </li>
              <li>
                <Link to="/works"> Works </Link>
              </li>

              <li>
                <Link to="/#About"> About me </Link>
              </li>
              <li>
                <Link to="#Conntect"> Conntect </Link>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}
